import { CardNumberElementComponent } from "@stripe/react-stripe-js";
import {
  PaymentMethod as StripePaymentMethod,
  PaymentMethodResult,
  Stripe,
  StripeElements,
} from "@stripe/stripe-js";
import { PaymentMethodForm } from "@types-runway/billing";
import { PaymentMethodDTO } from "@utils/billing/PaymentMethodDTO";

const useCreatePaymentMethod = () => {
  const createPaymentMethod = async (
    paymentMethodForm: PaymentMethodForm,
    stripe: Stripe | null,
    elements: StripeElements | null,
    cardComponent: CardNumberElementComponent
  ): Promise<PaymentMethodResult | undefined> => {
    const card = elements?.getElement(cardComponent) || { token: "" };
    const newPaymentMethodResult = await stripe?.createPaymentMethod({
      type: "card",
      card,
      billing_details: {
        name: paymentMethodForm.nameOnCard.value as string,
        address: {
          postal_code: paymentMethodForm.zipCode.value as string,
        },
      },
    });
    return newPaymentMethodResult;
  };

  const mapStripePaymentMethodToDTO = (stripePaymentMethod: StripePaymentMethod) => {
    const paymentMethod = new PaymentMethodDTO(stripePaymentMethod);
    return paymentMethod;
  };

  return { createPaymentMethod, mapStripePaymentMethodToDTO };
};

export default useCreatePaymentMethod;
